<template>
    <div>
        <Slider :slider="slider" :content="page" overview="true" calendar="all" filter="true" style="min-height: 100vh" class="kalender" >

        </Slider>
        <Leistungsliste :leistungen="all" :small="true">
            Unsere Kurse
        </Leistungsliste>
    </div>
</template>

<script>
    import store from '@/store';

    export default {
        store,
        name: 'Kurse',
        data() {
            return {}
        },
        created() {
            store.dispatch('getPageBySlug', {slug: 'kurse', type: 'pages'})
            store.commit('emptyFilter', {type: 'type'})
            store.commit('addFilter', {type: 'type', id: 7})
        },
        watch: {
            $route() {
                store.dispatch('getPageBySlug', {slug: 'kurse', type: 'pages'})
            }
        },
        components: {
            Slider: () => import('@/components/parts/Slider'),
            Leistungsliste: () => import('@/components/parts/Leistungsliste'),
            // Blocks: () => import('@/components/parts/Blocks'),
        },
        methods: {},
        computed: {
            page() {
                return store.state.page
            },
            all() {
                return store.state.all
            },
            kurse() {
                return store.state.kurse
            },
            slider() {
                if (store.state.page) return store.state.page.acf ? store.state.page.acf.bilder : []
                else return []
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/endpoints/Kurse.vue